// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-bqBmR";
var _4 = "formControl-2ALqx";
var _5 = "label-1sO5L";
var _6 = "checkbox-134U7";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "formControl", _5 as "label", _6 as "checkbox" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "formControl": _4, "label": _5, "checkbox": _6 }
